export const FeaturedSummaryData = [
  {
    name: "BEST BUY",
    summary: "Produced Best Buy’s first IoT app for iOS and Android. The highly-rated app synthesized design and technology for a seamless experience across the physical and digital interfaces.",
    key: 0,
  },
  {
    name: "HIROAD",
    summary: "Through a unique partnership and cross-team collaboration, we built an end-to-end framework with test-driven development that helped streamline and automate building a world-class application.",
    key: 1,
  },
  {
    name: "CRB AUTO",
    summary: "Designed and built a user experience that focused on ease of use and real time notifications. The CRB Auto app now supports thousands of users to manage and make payments on their loan.",
    key: 2,
  },
  {
    name: "LETSBLOOM",
    summary: "Created a platform built on security and compliance that helps bootstrap companies to be secure-by-design and compliant-by-default.",
    key: 3,
  },
  {
    name: "AAA ONLINE GARAGE",
    summary: "Produced native and responsive web apps, and introduced micro-services to support multiple vendors and strengthen scalability. The result was a better customer experience, simplified vendor replacement, and enhanced scalability.",
    key: 4,
  },
  {
    name: "BOHL",
    summary: "Built a nutrition-forward ordering platform for mobile and in-store kiosks. Real-time macro tracking turns choices into clarity, while Square and DoorDash integrations power effortless pickup, delivery, and counter service.",
    key: 5,
  },
  {
    name: "VERANT ID",
    summary: "Launched an app-free web verification platform with two flexible paths—Face Verification and DMV Verification. Users can complete either or both, with clear results and a searchable verification history inside the client portal.",
    key: 6,
  },
  {
    name: "FIREBREAK",
    summary: "Built an iOS app that turns a five-minute, photo-guided walk-around into a wildfire risk score and a prioritized list of the top actions to harden a home—complete with an illustrated report homeowners can share with neighbors, local fire departments, and insurers.",
    key: 7,
  }
];
